// src/permissions/permissions.js
import React, { useContext } from "react";
import { AuthContext } from "../base/context/authcontext";

// Helpers base (mismos criterios que en ProtectedRoute)
const getFlag = (perms, moduleKey, action = "can_access_module") =>
  Boolean(perms?.[moduleKey]?.[action]);

const evalSingle = (perms, rule) => {
  if (!rule) return true;
  const { module: moduleKey, action = "can_access_module" } = rule;
  if (!moduleKey) return true;
  return getFlag(perms, moduleKey, action);
};

const evalRules = (perms, require) => {
  if (!require) return true;

  if (require.module) return evalSingle(perms, require);

  if (Array.isArray(require.anyOf)) {
    return require.anyOf.some((r) => evalSingle(perms, r));
  }

  if (Array.isArray(require.allOf)) {
    return require.allOf.every((r) => evalSingle(perms, r));
  }

  return true;
};

// Hook para consultar permisos desde cualquier componente
export const useCan = () => {
  const { authData } = useContext(AuthContext);
  const permissions = authData?.user_data?.role?.permissions || {};
  const can = (require) => evalRules(permissions, require);
  return { can, permissions };
};

// Envoltorio genérico: muestra children si se cumplen permisos
export const IfAllowed = ({ require, children, fallback = null }) => {
  const { can } = useCan();
  return can(require) ? <>{children}</> : <>{fallback}</>;
};

// Atajo para "si tiene acceso a algún módulo de admin"
export const IfAnyAdmin = ({ children, fallback = null }) => {
  return (
    <IfAllowed
      require={{
        anyOf: [
          { module: "admin_property" },
          { module: "admin_user" },
          { module: "admin_roles" },
        ],
      }}
      fallback={fallback}
    >
      {children}
    </IfAllowed>
  );
};
